import { render, staticRenderFns } from "./PDP.vue?vue&type=template&id=2fe44cc3&scoped=true&"
import script from "./PDP.vue?vue&type=script&lang=js&"
export * from "./PDP.vue?vue&type=script&lang=js&"
import style0 from "./PDP.vue?vue&type=style&index=0&id=2fe44cc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe44cc3",
  null
  
)

export default component.exports